import React, { useState } from "react";
import Modal from "@visiblethread/react-components/dist/components/Modal";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import infoIcon from "icons/info-new-rows.svg";
import { importUsersFromCsv } from "slices/systemAdmin/actions/users";
import FileImport from "components/FileImport";
import { importUsersWithRolesFromCsv } from "slices/userAdmin/actions/userAdmin";
import Field, { fieldTypes } from "components/Field";

const ImportUsersModal = () => {
  const dispatch = useDispatch();

  const [selectedFile, setSelectedFile] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const isUserNamePassword = useSelector(
    (state) => state?.systemAdmin.isUsernamePassword
  );

  const isSsoDisabled = () => selectedFile !== "";
  const isUserPassDisabled = () =>
    selectedFile !== "" &&
    password !== "" &&
    confirmPassword !== "" &&
    passwordError === "" &&
    confirmPasswordError === "";

  const isOkButtonEnabled = () =>
    isUserNamePassword ? isUserPassDisabled() : isSsoDisabled();

  const handleSubmit = () => {
    if (isOkButtonEnabled()) {
      const formData = new FormData();
      formData.append("usersFile", selectedFile, selectedFile.name);
      formData.append("password", password);

      if (window.location.pathname.includes("/systemAdmin/")) {
        dispatch(importUsersFromCsv(formData));
      } else {
        dispatch(importUsersWithRolesFromCsv(formData));
      }
    }
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const onEnterKeyDown = ({ key }) => {
    if (key === "Enter" && isOkButtonEnabled()) {
      handleSubmit();
    }
  };

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.IMPORT_USERS));
  };

  const formatExampleBody = () => (
    <div className="import__users__modal__format">
      <span>Format Example</span>
      <blockquote>
        {window.location.pathname.includes("/systemAdmin/") ? (
          <small>
            <strong>CSV Columns: </strong>email, name, surname <br />
            john.doe@example, John, Doe <br />
            jane.doe@example, Jane, Doe
          </small>
        ) : (
          <small>
            <strong>CSV Columns: </strong>email, name, surname, licensed,
            usersAdmin, readabilitySettings, acronymSettings, discoverySettings,
            excelOutputs, dictionaryAdmin, <br />
            john.doe@example, John, Doe, true, true, true, true, true, true,
            true <br />
            jane.doe@example, Jane, Doe, false, true, false, false, false,
            false, false
          </small>
        )}
      </blockquote>
    </div>
  );

  const passwordBody = () => (
    <div className="import__users__modal__password">
      <span data-title="Every user will have their password reset to this One Time password. The first time a user logs in using this One Time password they will be forced to provide a new password to secure their future logins. The password must be at least 8 characters long and contain at least 1 letter and 1 number.">
        <strong>One Time Password</strong>
        <img src={infoIcon} alt="info icon" />
      </span>
      <Field
        type={fieldTypes.passwordAndConfirm}
        propsObject={{
          password,
          setPassword,
          passwordError,
          setPasswordError,
          confirmPassword,
          setConfirmPassword,
          confirmPasswordError,
          setConfirmPasswordError,
        }}
      />
    </div>
  );

  return (
    <Modal
      data-test="newUserModal"
      className="fade-in"
      show
      onDismiss={handleCancel}
      backdrop="static"
      centered
      onKeyDown={onEnterKeyDown}
    >
      <Modal.Header closeButton>
        <b className="import__users__modal__header">Import Users From CSV</b>
      </Modal.Header>
      <Modal.Body>
        <div className="import__users__modal">
          <FileImport
            accepts=".csv"
            handleFileChange={handleFileChange}
            selectedFile={selectedFile}
          />
          {formatExampleBody()}
          {isUserNamePassword && passwordBody()}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          dataTestId="saveButton"
          variant={buttonVariants.primary}
          onClick={handleSubmit}
          disabled={!isOkButtonEnabled()}
          content="Add User(s)"
        />
        <Button
          dataTestId="cancelButton"
          variant={buttonVariants.secondary}
          onClick={handleCancel}
          content="Cancel"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default ImportUsersModal;
